import Controller from './Controller';
import RadioGroupWrapper from './RadioGroupWrapper';

export type { RadioGroupProps } from './RadioGroup.types';

export default Object.assign(RadioGroupWrapper, {
  Controller,
});
